import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import api from "../api/client";
import "./Auth.css";

export default function Register() {
  const [form, setForm] = useState({ fname: "", email: "", mobile: "", password: "" });
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);
  const { login, user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => { if (user) navigate("/"); }, [user, navigate]);

  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  async function handleSubmit(e) {
    e.preventDefault();
    if (!form.fname || !form.email || !form.mobile || !form.password) return setError("Fill all fields.");
    if (form.password.length < 8) return setError("Password must be 8+ characters.");
    setBusy(true); setError(null);
    try {
      const { data } = await api.post("/user/register", form);
      login(data.token, data.user);
      navigate("/");
    } catch (err) {
      setError(err.response?.data?.message || "Registration failed.");
    } finally {
      setBusy(false);
    }
  }

  // Google Sign-In
  useEffect(() => {
    const id = process.env.REACT_APP_GOOGLE_CLIENT_ID;
    if (!id) return;

    const script = document.createElement("script");
    script.src = "https://accounts.google.com/gsi/client";
    script.async = true;
    script.onload = () => {
      window.google.accounts.id.initialize({
        client_id: id,
        callback: handleGoogle,
      });
      window.google.accounts.id.renderButton(
        document.getElementById("google-btn-reg"),
        { theme: "filled_black", size: "large", width: "100%", shape: "pill", text: "signup_with" }
      );
    };
    document.body.appendChild(script);
    return () => { try { document.body.removeChild(script); } catch {} };
  }, []);

  async function handleGoogle(response) {
    setError(null); setBusy(true);
    try {
      const { data } = await api.post("/user/google-login", { credential: response.credential });
      login(data.token, data.user);
      navigate("/");
    } catch (err) {
      setError(err.response?.data?.message || "Google sign up failed.");
    } finally { setBusy(false); }
  }

  return (
    <div className="auth-wrapper">
      <div className="auth-left">
        <div className="auth-left-content">
          <h1>ALREADY HAVE AN<br />ACCOUNT?</h1>
          <p>Sign in to your existing account and continue your gaming journey.</p>
          <Link to="/login" className="auth-outline-btn">SIGN IN</Link>
        </div>
      </div>
      <div className="auth-right">
        <div className="auth-card">
          <h2>CREATE ACCOUNT</h2>

          <form onSubmit={handleSubmit}>
            <input className="auth-input" type="text" placeholder="Full Name" value={form.fname}
              onChange={(e) => set("fname", e.target.value)} />
            <input className="auth-input" type="email" placeholder="Email" value={form.email}
              onChange={(e) => set("email", e.target.value)} />
            <input className="auth-input" type="tel" placeholder="Mobile Number" value={form.mobile}
              onChange={(e) => set("mobile", e.target.value)} />
            <input className="auth-input" type="password" placeholder="Password (min 8 chars)" value={form.password}
              onChange={(e) => set("password", e.target.value)} />

            {error && <p className="auth-error">{error}</p>}

            <button className="auth-btn" type="submit" disabled={busy}>
              {busy ? "Creating…" : "Create Account"}
            </button>
          </form>

          <div className="auth-divider"><span>or sign up with</span></div>

          <div id="google-btn-reg" className="google-btn-wrap"></div>

          <p className="auth-footer-text">
            By creating an account, you agree to our <Link to="/privacy">Privacy Policy</Link> and <Link to="/terms">Terms of Service</Link>
          </p>
        </div>
      </div>
    </div>
  );
}